<template>
  <transition
    name="p-message"
    appear
  >
    <div
      v-if="visible"
      :class="containerClass"
      role="alert"
    >
      <div class="p-message-wrapper">
        <span :class="iconClass" />
        <div class="p-message-text">
          <slot />
        </div>
        <button
          v-if="closable"
          v-ripple
          class="p-message-close p-link"
          type="button"
          @click="visible = false"
        >
          <i class="p-message-close-icon pi pi-times" />
        </button>
      </div>
    </div>
  </transition>
</template>

<script>
import Ripple from '../ripple/Ripple';

export default {
    directives: {
        'ripple': Ripple
    },
    props: {
        severity: {
            type: String,
            default: 'info'
        },
        closable: {
            type: Boolean,
            default: true
        },
        sticky: {
            type: Boolean,
            default: true
        },
        life: {
            type: Number,
            default: 3000
        }
    },
    timeout: null,
    data() {
        return {
            visible: true
        }
    },
    computed: {
        containerClass() {
            return 'rounded-md px-5 py-2 mt-2 bg-theme-6 text-white p-message-' + this.severity;
        },
        iconClass() {
            return ['ri-close-fill mr-2', {
                'pi-info-circle': this.severity === 'info',
                'pi-check': this.severity === 'success',
                'pi-exclamation-triangle': this.severity === 'warn',
                'pi-times-circle': this.severity === 'error'
            }];
        }
    },
    mounted() {
        if (!this.sticky) {
            setTimeout(() => {
                this.visible = false;
            }, this.life);
        }
    }
}
</script>

<style>
.p-message-wrapper {
    display: flex;
    align-items: center;
}

.p-message-close {
    display: flex;
    align-items: center;
    justify-content: center;
}

.p-message-close.p-link {
    margin-left: auto;
    overflow: hidden;
    position: relative;
}

.p-message-enter-from {
    opacity: 0;
}

.p-message-enter-active {
    transition: opacity .3s;
}

.p-message.p-message-leave-from {
    max-height: 1000px;
}

.p-message.p-message-leave-to {
    max-height: 0;
    opacity: 0;
    margin: 0 !important;
}

.p-message-leave-active {
    overflow: hidden;
    transition: max-height .3s cubic-bezier(0, 1, 0, 1), opacity .3s, margin .15s;
}

.p-message-leave-active .p-message-close {
    display: none;
}
</style>
